var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "emd-container" }, [
    _c("div", { staticClass: "el-section" }, [
      _c("div", { staticClass: "eu-container" }, [
        _c("div", { staticClass: "eu-flex eu-justify_center" }, [
          _c(
            "div",
            {
              staticClass:
                "eu-flex-item eu-basis_8_sm eu-basis_6_md eu-basis_5_lg eu-align_center",
            },
            [
              _vm.emailError.status
                ? _c("emd-alert", {
                    attrs: {
                      variant: "danger",
                      title: _vm.$t(_vm.emailError.title),
                      message: _vm.$t(_vm.emailError.message),
                      autoclose: "",
                    },
                    on: {
                      cancel: function ($event) {
                        _vm.emailError.status = false
                      },
                    },
                  })
                : _vm._e(),
              _vm.showCardSuccessTexts
                ? _c(
                    "section",
                    { staticClass: "el-section" },
                    [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "el-chunk" }, [
                          _c(
                            "span",
                            {
                              staticClass: "emd-text",
                              class: {
                                _color_warning: _vm.status === "processing",
                                _color_success:
                                  _vm.status === "paid" ||
                                  !_vm.selectedPaymentTypeItems,
                                _color_info: _vm.status === "pending",
                              },
                            },
                            [
                              _vm.status === "paid" ||
                              !_vm.selectedPaymentTypeItems
                                ? _c("i", {
                                    staticClass: "uil uil-check-circle",
                                    staticStyle: { "font-size": "3rem" },
                                  })
                                : _vm._e(),
                              _vm.status === "processing"
                                ? _c("i", {
                                    staticClass: "uil uil-hourglass",
                                    staticStyle: { "font-size": "3rem" },
                                  })
                                : _vm._e(),
                              _vm.status === "pending"
                                ? _c("i", {
                                    staticClass: "uil uil-info-circle",
                                    staticStyle: { "font-size": "3rem" },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "el-chunk" }, [
                          _vm.status === "paid" || !_vm.selectedPaymentTypeItems
                            ? _c("h2", { staticClass: "emd-text _size_page" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        _vm.selectedPaymentType +
                                          ".payment.approved"
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          _vm.status === "processing"
                            ? _c("h2", { staticClass: "emd-text _size_page" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        _vm.selectedPaymentType +
                                          ".payment.pending"
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          _vm.status === "pending"
                            ? _c("h2", { staticClass: "emd-text _size_page" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        _vm.selectedPaymentType +
                                          ".payment.auth_only"
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm.status === "paid" || !_vm.selectedPaymentTypeItems
                        ? _c("p", { staticClass: "el-chunk" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.selectedPaymentType + ".status.approved"
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _vm.status === "processing"
                        ? _c("p", { staticClass: "el-chunk" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.selectedPaymentType + ".status.pending",
                                    { creditCard: _vm.creditCard }
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _vm.status === "pending"
                        ? _c("p", { staticClass: "el-chunk" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.selectedPaymentType +
                                      ".status.auth_only"
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _c("order-created-share", {
                        on: { emailError: _vm.setEmailError },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.payment_method === "boleto"
                ? _c(
                    "section",
                    { staticClass: "el-section" },
                    [
                      _c("div", { staticClass: "el-chunk" }, [
                        _vm._m(0),
                        _c("div", { staticClass: "el-chunk" }, [
                          _c("h2", { staticClass: "emd-text _size_page" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.selectedPaymentType + ".payment.paid"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                      ]),
                      _c("p", { staticClass: "el-chunk" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                _vm.selectedPaymentType + ".status.paid.boleto",
                                {
                                  due_at: _vm.due_at,
                                  totalAmount: _vm.totalAmount,
                                }
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-container _type_card" }, [
                          _c("div", { staticClass: "emd-container__content" }, [
                            _c(
                              "div",
                              {
                                staticClass: "emd-copy eu-justify_center",
                                class: { _copied: _vm.copied },
                                on: {
                                  click: function ($event) {
                                    return _vm.copy("boleto_code")
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "emd-copy__icon",
                                    attrs: { title: "copiar" },
                                  },
                                  [
                                    _vm.copied
                                      ? _c("i", {
                                          staticClass: "uil uil-check-circle",
                                        })
                                      : _c("i", {
                                          staticClass: "uil uil-copy-alt",
                                        }),
                                  ]
                                ),
                                _c(
                                  "p",
                                  {
                                    ref: "boleto_code",
                                    staticClass: "emd-copy__text eu-grow_0",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          this.createdOrderResponse.payment_url
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                      _c("order-created-share", {
                        on: { emailError: _vm.setEmailError },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.payment_method === "checkout"
                ? _c(
                    "section",
                    { staticClass: "el-section" },
                    [
                      _c("div", { staticClass: "el-chunk" }, [
                        _vm._m(1),
                        _c("div", { staticClass: "el-chunk" }, [
                          _c("h2", { staticClass: "emd-text _size_page" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.selectedPaymentType + ".payment.paid"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                      ]),
                      _c("p", { staticClass: "el-chunk" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                _vm.selectedPaymentType +
                                  ".status.paid.checkout",
                                {
                                  orderId: _vm.orderId,
                                  totalAmount: _vm.totalAmount,
                                }
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-container _type_card" }, [
                          _c("div", { staticClass: "emd-container__content" }, [
                            _c(
                              "div",
                              {
                                staticClass: "emd-copy eu-justify_center",
                                class: { _copied: _vm.copied },
                                on: {
                                  click: function ($event) {
                                    return _vm.copy("payment_link")
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "emd-copy__icon",
                                    attrs: { title: "copiar" },
                                  },
                                  [
                                    _vm.copied
                                      ? _c("i", {
                                          staticClass: "uil uil-check-circle",
                                        })
                                      : _c("i", {
                                          staticClass: "uil uil-copy-alt",
                                        }),
                                  ]
                                ),
                                _c(
                                  "p",
                                  {
                                    ref: "payment_link",
                                    staticClass: "emd-copy__text eu-grow_0",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.createdOrderResponse.payment_url
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                      _c("order-created-share", {
                        on: { emailError: _vm.setEmailError },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.payment_method === "pix"
                ? _c("pix-order-created", {
                    attrs: {
                      paymentMethod: _vm.payment_method,
                      totalAmount: _vm.totalAmount,
                    },
                  })
                : _vm._e(),
              _vm.payment_method === "pix"
                ? _c("order-created-share", {
                    on: { emailError: _vm.setEmailError },
                  })
                : _vm._e(),
              _c("section", { staticClass: "el-section" }, [
                _c("div", { staticClass: "eu-flex eu-column eu-row_sm" }, [
                  _c("div", { staticClass: "eu-flex-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "emd-btn _type_text _color_primary",
                        attrs: {
                          href: _vm.$sanitize(_vm.viewOrder),
                          target: "_blank",
                          rel: "noopener",
                        },
                      },
                      [
                        _c("i", { staticClass: "uil uil-external-link-alt" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(_vm.selectedPaymentType + ".viewOrder")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "eu-flex-item" }, [
                    _c(
                      "button",
                      {
                        staticClass: "emd-btn _color_primary",
                        on: { click: _vm.resetApplication },
                      },
                      [
                        _c("i", { staticClass: "uil uil-plus" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(_vm.selectedPaymentType + ".createNew")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-chunk" }, [
      _c("span", { staticClass: "emd-text _color_success" }, [
        _c("i", {
          staticClass: "uil uil-check-circle",
          staticStyle: { "font-size": "3rem" },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-chunk" }, [
      _c("span", { staticClass: "emd-text _color_success" }, [
        _c("i", {
          staticClass: "uil uil-check-circle",
          staticStyle: { "font-size": "3rem" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }